import { Api } from '../../../api/models/apis';
import { TpConfirmData, promptConfirmationBox } from '../../../components/message-boxes/ConfirmBox';

const EULA_VERSION = import.meta.env.VITE_EULA_VERSION;
const EULA_URL = import.meta.env.VITE_EULA_URL;
const PRIVACY_URL = import.meta.env.VITE_PRIVACY_URL;

export function promptAcceptEula(api: Api): Promise<void> {
  const form: TpConfirmData = {
    title: `End User License Agreement (EULA)`,
    description: `By clicking Confirm, you agree to the <a href="${EULA_URL}" target="_blank" rel="noopener noreferrer">EULA</a> and <a href="${PRIVACY_URL}" target="_blank" rel="noopener noreferrer">Privacy Policy</a>`,
  };

  return promptConfirmationBox(form)
    .then(() => {
      return api.user.setAcceptedEulaVersion(EULA_VERSION);
    })
    .catch(() => {
      throw 'EULA not Accepted!';
    });
}
